import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colours = tokens.colors;
var bodyBold = designTokenFonts.bodyBold,
  mini = designTokenFonts.mini,
  miniBold = designTokenFonts.miniBold;
export var text = /*#__PURE__*/css("color:", colours.neutral.heavy.default, ";", media('<tablet'), "{", mini, ";}");
export var autocomplete = /*#__PURE__*/css("width:449px;margin-top:8px;", media('<tablet'), "{width:100%;}");
export var address = /*#__PURE__*/css(bodyBold, ";", media('<tablet'), "{", miniBold, ";}");
export var changeAddress = /*#__PURE__*/css("color:", colours.interactive.base.default, ";&:hover{color:", colours.interactive.base.hover, ";cursor:pointer;}", media('<tablet'), "{", mini, ";}");